import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { CanActivate, Router} from '@angular/router';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate  {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {
  }

  canActivate(): boolean  {
    if (environment.security) {
      if (!this.authService.isAuthenticate()) {
        void this.router.navigate(['login']);
        return false;
      }
      return true;
    } else {
      return true;
    }
  }

}
